import { LibraryApiModel } from '../../../types/models/library.model';
import { SymbolApiModel } from '../../../types/models/symbol.model';
import { CreateSymbolApiRequest } from '../../../types/requests/symbols/create-symbol.request';
import { DeleteSymbolApiRequest } from '../../../types/requests/symbols/delete-symbol.request';
import { GetSymbolApiRequest } from '../../../types/requests/symbols/get-symbol.request';
import { CreateLibraryApiRequest } from '../../../types/requests/symbols/libraries/create-libary.request';
import { SearchLibrariesApiRequest } from '../../../types/requests/symbols/libraries/search-libraries.request';
import { SearchSymbolsApiRequest } from '../../../types/requests/symbols/search-symbols.request';
import { UpdateSymbolApiRequest } from '../../../types/requests/symbols/update-symbol.request';
import { CursorPaginatedApiResponse } from '../../../types/responses/cursor-paginated.response';
import { client } from './client';

export const createSymbol = (params: CreateSymbolApiRequest) => client.post<SymbolApiModel>('/symbols', params);

export const updateSymbol = ({ symbolId, ...params }: UpdateSymbolApiRequest) =>
  client.patch<SymbolApiModel>(`/symbols/${symbolId}`, params);

export const getSymbol = <T extends SymbolApiModel>({ symbolId, ...params }: GetSymbolApiRequest) =>
  client.get<T>(`/symbols/${symbolId}`, { params });

export const searchSymbols = <T extends SymbolApiModel>(params: SearchSymbolsApiRequest) =>
  client.get<CursorPaginatedApiResponse<T>>(`/symbols`, { params });

export const deleteSymbol = ({ symbolId }: DeleteSymbolApiRequest) => client.delete<void>(`/symbols/${symbolId}`);

export const createLibrary = (params: CreateLibraryApiRequest) => client.post<LibraryApiModel>('/symbols/libraries', params);

export const searchLibraries = (params: SearchLibrariesApiRequest) =>
  client.get<CursorPaginatedApiResponse<LibraryApiModel>>(`/symbols/libraries`, { params });
